import {
  EFFORT_STATUS_TYPE_ENUM,
  getEffortStatusTypeTranslated,
  PROJECT_STEP_STATUS_TYPE_ENUM,
  getProjectStepStatusTypeTranslated,
} from 'enums';
import { Chip, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction } from 'react';

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

type ChipsArrayProps = {
  type: 'effort' | 'projectTask';
  disabled?: boolean;
  statusType: number | null;
  setStatusType: Dispatch<SetStateAction<number | null>>;
  showOnlyAssignedToMe?: boolean;
  setShowOnlyAssignedToMe?: Dispatch<SetStateAction<boolean>>;
};

const ChipsArray = ({
  type = 'effort',
  disabled = false,
  statusType,
  setStatusType,
  showOnlyAssignedToMe = false,
  setShowOnlyAssignedToMe = undefined,
}: ChipsArrayProps) => {
  const _enum = type === 'effort' ? EFFORT_STATUS_TYPE_ENUM : PROJECT_STEP_STATUS_TYPE_ENUM;
  const _translate = type === 'effort' ? getEffortStatusTypeTranslated : getProjectStepStatusTypeTranslated;

  return (
    <Paper
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        listStyle: 'none',
        py: 1,
        px: 0.5,
        m: 0,
        mt: 1,
        borderRadius: '8px',
        width: { xs: '100vw', md: 'calc(100vw - 308px)' },
      }}
      component="ul">
      <ListItem>
        <Chip
          color={statusType === null && !showOnlyAssignedToMe ? 'primary' : 'default'}
          label={<FormattedMessage id="general.all" defaultMessage="Hepsi" />}
          onClick={
            !disabled
              ? () => {
                  setStatusType(null);
                  setShowOnlyAssignedToMe?.(false);
                }
              : undefined
          }
        />
      </ListItem>
      {setShowOnlyAssignedToMe && (
        <ListItem>
          <Chip
            color={statusType === null && showOnlyAssignedToMe ? 'primary' : 'default'}
            label={<FormattedMessage id="general.assignedToMe" defaultMessage="Bana Atananlar" />}
            onClick={
              !disabled
                ? () => {
                    setStatusType(null);
                    setShowOnlyAssignedToMe(true);
                  }
                : undefined
            }
          />
        </ListItem>
      )}
      {Object.values(_enum)
        .filter((v) => typeof v === 'number')
        .map((v, idx) => {
          return (
            <ListItem key={idx}>
              <Chip
                color={statusType === v ? 'primary' : 'default'}
                label={_translate(v)}
                onClick={
                  !disabled
                    ? () => {
                        setStatusType(v as number);
                        setShowOnlyAssignedToMe?.(false);
                      }
                    : undefined
                }
              />
            </ListItem>
          );
        })}
    </Paper>
  );
};

export default ChipsArray;
